import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { Contact } from '../components/Contact';
import { SectionNav } from '../components/SectionNav';
export function ContactPage() {
  return <>
      <PageHeader index="10" title="Board Inquiry & Direct Contact Portal" intro="A single, confidential route for nominating committees, chairs, and executive search firms to open a conversation." data-id="element-340" data-mp="spzpceqcay7y" />
      <Contact data-id="element-341" data-mp="10whyq35p7r3" />
      <SectionNav currentIndex="10" data-id="element-342" data-mp="1166e98jz6uo" />
    </>;
}